export default {
  computed: {
    isSafariIos: function () {
      let ua = window.navigator.userAgent
      let iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i)
      let webkit = !!ua.match(/WebKit/i)
      return iOS && webkit && !ua.match(/CriOS/i)
    },
  },
}
